import { css } from "@compiled/react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import { TemplateType } from "@/content/templates/template.types";
import { ZoomIn } from "@/libraries/wpl/foundations/src/icons/content/zoom-in";
import { ZoomOut } from "@/libraries/wpl/foundations/src/icons/content/zoom-out";

const previewTopBar = css({
    display: "flex",
    padding: "6px 12px",
    height: "16px",
    boxSizing: "border-box",
    borderStartStartRadius: "4px",
    borderStartEndRadius: "4px",
    backgroundColor: "#172b4d"
});
const previewBarDot = css({
    marginInlineEnd: 4,
    width: 5,
    height: 5,
    backgroundColor: "#ffffff",
    borderRadius: "50%"
});

const previewImage = css({
    width: "100%",
    maxWidth: "100%"
});

export interface TemplatePreviewWindowProps {
    url: string;
    alt: string;
    templateType?: TemplateType;
}

export const TemplatePreviewWindow = ({
    url,
    alt,
    templateType
}: TemplatePreviewWindowProps) => {
    const templatePreview = css({
        maxWidth: "100%",
        margin: "0 auto"
    });

    const previewScreenshot = css({
        "height": 360,
        "overflowY": "auto",
        "backgroundColor": "#ffffff",
        "borderEndStartRadius": 4,
        "borderEndEndRadius": 4,
        "boxShadow": "1px 1px 6px 0 rgba(0,0,0,.1)",

        "@media (max-width: 39.99rem)": {
            height: "198px",
            overflowY: "hidden"
        }
    });

    const whiteboardPreviewWrapper = css({
        "cursor": "grab",

        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".react-transform-wrapper ": {
            height: "100%"
        }
    });

    const zoomControls = css({
        display: "flex",
        gap: "8px",
        position: "absolute",
        insetBlockEnd: "16px",
        insetInlineEnd: "16px"
    });

    const zoomControl = css({
        padding: 0,
        border: 0,
        background: "none",
        cursor: "pointer"
    });

    return (
        <div css={templatePreview}>
            {templateType === TemplateType.Whiteboard ? (
                <>
                    <div css={previewTopBar}>
                        <div css={previewBarDot} />
                        <div css={previewBarDot} />
                        <div css={previewBarDot} />
                    </div>
                    <div css={[previewScreenshot, whiteboardPreviewWrapper]}>
                        <TransformWrapper>
                            {({ zoomIn, zoomOut }) => (
                                <>
                                    <TransformComponent>
                                        {/* eslint-disable-next-line no-restricted-syntax */}
                                        <img
                                            css={previewImage}
                                            src={url}
                                            alt={alt}
                                        />
                                    </TransformComponent>
                                    <div css={zoomControls}>
                                        <button
                                            css={zoomControl}
                                            onClick={() => zoomIn()}
                                            aria-label="Zoom In"
                                        >
                                            <ZoomIn size="16" />
                                        </button>
                                        <button
                                            css={zoomControl}
                                            onClick={() => zoomOut()}
                                            aria-label="Zoom Out"
                                        >
                                            <ZoomOut size="16" />
                                        </button>
                                    </div>
                                </>
                            )}
                        </TransformWrapper>
                    </div>
                </>
            ) : (
                <>
                    <div css={previewTopBar}>
                        <div css={previewBarDot} />
                        <div css={previewBarDot} />
                        <div css={previewBarDot} />
                    </div>
                    <div css={previewScreenshot}>
                        {/* eslint-disable-next-line no-restricted-syntax */}
                        <img css={previewImage} src={url} alt={alt} />
                    </div>
                </>
            )}
        </div>
    );
};
